declare module "iron-session" {
  interface IronSessionData {
    token?: any;
  }
}
import cookie from "cookie";
import {
  clear2faDateCookie,
  set2faDateCookie,
  setLoginDateCookie,
} from "./cookieHelper";
import { withIronSessionApiRoute } from "iron-session/next";
import { sessionOptions } from "./session";
const nextManage2fa = withIronSessionApiRoute(async (req, res) => {
  try {
    switch (req.method) {
      case "GET": {
        const cookies = cookie.parse(req.headers.cookie || "");
        const date = cookies["2fa_verified_date"];
        return res.status(200).json({ date: date || null });
      }

      case "POST": {
        res.setHeader("Set-Cookie", [set2faDateCookie]);
        res.setHeader("Content-Type", "application/json");

        return res.status(200).json({ status: "set" });
      }

      case "DELETE": {
        res.setHeader("Set-Cookie", clear2faDateCookie);
        return res.status(200).json({ status: "cleared" });
      }
      default:
        return res.status(405).json({ error: "Method Not Allowed" });
    }
  } catch (err) {
    return res
      .status(500)
      .json({ error: "Internal Server Error", detail: err });
  }
}, sessionOptions);

export default nextManage2fa;
